export const addInfoToLocalStorage = (data: any) => {
    localStorage.setItem("token", data.token);
    localStorage.setItem("user_id", data.user_id);
    //   localStorage.setItem("email", data.email);
  };